var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getTestId, RED_400, WHITE } from '@airtel/air-design-system';
var LinkListItemWidget = null;
var StatusCardWidget = null;
export var withErrorStatus = Component => {
  var Wrapper = props => {
    var _props$showErrorStatu = props.showErrorStatus,
      showErrorStatus = _props$showErrorStatu === void 0 ? false : _props$showErrorStatu,
      _props$errorStatusPro = props.errorStatusProps,
      errorStatusProps = _props$errorStatusPro === void 0 ? {} : _props$errorStatusPro,
      restProps = __rest(props, ["showErrorStatus", "errorStatusProps"]);
    var onUserAction = props.onUserAction;
    var innerWrapperComponent = () => {
      if ((errorStatusProps === null || errorStatusProps === void 0 ? void 0 : errorStatusProps.kind) === 'LinkListItem') {
        if (LinkListItemWidget == null) {
          LinkListItemWidget = require('../../components/link-list-item-widget').LinkListItemWidget;
        }
        return _jsx(LinkListItemWidget, Object.assign({}, getTestId(props.testID, 'withErrorStatus'), {
          withCard: true,
          withCardProps: {
            noPadding: true
          },
          roundedCorners: true,
          avatarIcon: "CancelIcon",
          heading: "Failed to load",
          subHeading: "there was an error loading",
          actionType: "button",
          actionTypeProps: {
            buttonText: 'Retry'
          },
          actionTypePosition: "center",
          avatarProps: {
            iconProps: {
              color: WHITE
            },
            style: {
              backgroundColor: RED_400
            }
          }
        }, errorStatusProps, {
          onUserAction: onUserAction
        }));
      }
      if (StatusCardWidget == null) {
        StatusCardWidget = require('../../components/status-card-widget').StatusCardWidget;
      }
      var errorStatusDefaultProps = Object.assign(Object.assign({
        type: 'image',
        statusCardImage: {
          imageUrl: 'https://assets.airtel.in/static-assets/shifting-journey/xxxhdpi/man-with-question.png',
          size: 'lg'
        },
        ctaTitle: 'try again',
        title: {
          text: 'something went wrong'
        }
      }, errorStatusProps), {
        onUserAction: onUserAction
      });
      return _jsx(StatusCardWidget, Object.assign({}, errorStatusDefaultProps, getTestId(props.testID, 'withErrorStatus')));
    };
    return _jsx(_Fragment, {
      children: showErrorStatus ? innerWrapperComponent() : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};